<template>
  <div class="accordion" role="tablist">
    <div id="selectReservationTime" class="btb-label-lg mb-2">{{ reservationTimeTitle }}</div>
    <div class="my-3"
      v-for="(reservationGroup, time, index) in reservations" 
      :key="time"
    >
      <b-button pill variant="outline-dark"
        class="px-4" 
        v-b-toggle.accordion="`collapse-${ index }`"
      >
        {{ time }}
      </b-button>
      <b-collapse :id="`collapse-${ index }`" accordion="btb-reservation-accordion" 
        class="py-3" 
        role="tabpanel"
      >
        <!-- TODO: Should these be individual collapses? -->
        <b-form-group class="btb-reservation-header" label="Select your Booker:">
          <b-list-group>
            <b-list-group-item variant="secondary"
              v-for="reservation in reservationGroup"
              :key="reservation.id"
              @click="selectReservation(reservation)"
            >
              {{ getDisplayName(reservation.Booker.Person) }}
            </b-list-group-item>
          </b-list-group>
        </b-form-group>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import { getDisplayName } from '@/utils';

export const RESERVATION_SELECT_EVENTS = {
  SELECT: 'Reservation:Select',
}

export default {
  props: {
    reservations: {
      type: Object,
    }
  },
  data () {
    return {
      reservationTimeTitle: 'Please select your reservation time:',
    }
  },
  computed: {
    activeId () {
      return this.active && this.active.id;
    }
  },
  methods: {
    getDisplayName,
    selectReservation (reservation) {
      this.$emit(RESERVATION_SELECT_EVENTS.SELECT, reservation);
    },
  },
}
</script>

<style scoped>

</style>